import React from 'react';
import { pickupStopStatusCode } from '../../../Utils';
import { isValidPickupNumber } from '../../../../../utils';
import { NO_FREIGHT } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { getDriverStopDetails } from '../../../../../Dispatch/RouteExecution/ProDetails/PickupProInfo/utils';
import { withAppConfig } from '../../../../../../../appConfigContext';
import { withSnackbar } from 'notistack';
import { inject } from 'mobx-react';
import { getNoFreightStatusLabel } from '../../../../../Dispatch/utils/utils';

const PickupNumberValue = ({ stopData, route, classNames, highlighted, configJSON, enqueueSnackbar, classes, DispatchStore }) => {
  const navigate = useNavigate();
  const openPickupDetails = (pickupNumber) => {
    if (isValidPickupNumber(pickupNumber)) {
      const driverDetails= getDriverStopDetails({historicDriverDetails: {routeData: route, stopId: stopData.stopId}});
      navigate(`?pickupNumber=${pickupNumber}`, {
        state: {
          pickupInfo: null,
          driverDetails,
          shipmentAPI: 'GetPastPickupShipments', // The getPickupShipments API isn’t usable here since we don’t have a pickupId in this context.
          isPickupHistory: false,
          isPastPickup: true, // We use `isPastPickup = true` for both active and past pickups because in both cases we fetch the shipment list using the getPastPickupShipments API.
          closeOnRefresh: true,
          shouldGetShipmentsFromAPI: true,
          terminalCode: route.terminal.terminalCode,
          proImageApiName: route.isLiveDispatch ? 'GetImages' : 'StopImages'
        }
      });
    } else {
      enqueueSnackbar('Pickup details not found', {
        variant: 'error'
      });
    }
  };
  const status = pickupStopStatusCode(stopData);
  const statusText = status ? ` (${status})` : '';
  let noFreightCodeText = '';
  if (configJSON?.noFreightConfigParsed?.enableNoFreightCode && stopData.noFreightCode) {
    noFreightCodeText = `(${getNoFreightStatusLabel(stopData.noFreightCode, DispatchStore?.staticClientData?.clientCodes?.noFreightCode, configJSON?.enableReturnExceptionReasonLabels)})`;
  }
  const uniquePickupNumbers = [...new Set(stopData.shipments.map(s => s.pickupNumber))];
  return (
    uniquePickupNumbers.map((pickupNumber, index) => (
      <React.Fragment key={pickupNumber}>
        <span
          className={`${classes.underline} ${classNames(status === NO_FREIGHT, pickupNumber == highlighted)}`}
          onClick={() =>
            openPickupDetails(pickupNumber)
          }>{`${pickupNumber}${statusText} ${noFreightCodeText}`}
        </span>
        {index < uniquePickupNumbers.length - 1 && <span>, </span>}
      </React.Fragment>
    ))
  );
};

export default inject('DispatchStore')(withAppConfig(withSnackbar(PickupNumberValue)));
